import useModalContext from './useModalContext';
import {CSSStyles} from '../../../types/CSSStyles';
import RoundIconButton from '../../design_system/Button/RoundIconButton';
import useAppTheme from '../../design_system/hooks/useAppTheme';
import Close from '../../design_system/icon/Close';
import white from '../../design_system/theme/colors/white';
import Flex from '../flex/Flex';

import {css} from '@emotion/react';
import * as React from 'react';
import {useTranslation} from 'react-i18next';

export interface Props {
  readonly children: React.ReactNode;
  /**
   * @default true
   */
  readonly showCloseButton?: boolean;
  readonly sx?: CSSStyles;
}

export default function ModalBody(props: Props): JSX.Element {
  const {children, showCloseButton = true, sx} = props;
  const {t} = useTranslation();
  const {palettes, spacing} = useAppTheme();
  const {onClose} = useModalContext();

  return (
    <Flex
      css={[
        css({
          alignItems: 'flex-start',
          boxShizing: 'border-box',
          borderRadius: 6,
          padding: spacing.x32,
          backgroundColor: palettes.background.white.default,
          rowGap: spacing.x20,
          maxWidth: 'calc(100vw - 20px)',
          maxHeight: 'calc(100vh - 100px)',
          position: 'relative',
        }),
        sx,
      ]}
      direction="column"
    >
      {showCloseButton && (
        <RoundIconButton
          aria-label={t('common-strings.close')}
          icon={<Close />}
          sx={css({
            backgroundColor: white.solid,
            boxShadow: '0px 3px 9px 0px rgba(0, 0, 0, 0.16)',
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(50%, -50%)',
            zIndex: 2,
          })}
          onPress={onClose}
        />
      )}
      <div css={{width: '100%', height: '100%'}}>{children}</div>
    </Flex>
  );
}
